import FormattedMessage from 'I18n/components/FormattedMessage';
import { AT_ACTION_LIMIT, BELOW_ACTION_LIMIT, OVER_ACTION_LIMIT } from 'automation-ui-canvas/constants/ActionLimitStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
export const getFlowActionCount = flow => flow ? flow.getActions().size : 0;
export const getActionLimitStatus = (actionLimit, actionCount) => {
  const limit = actionLimit.getLimit();
  if (actionCount < limit) {
    return BELOW_ACTION_LIMIT;
  } else if (actionCount === limit) {
    return AT_ACTION_LIMIT;
  }
  return OVER_ACTION_LIMIT;
};

/**
 * Takes an ActionLimit and returns a message for workflows that are
 * at or over limit to render in a tooltip
 * @param {ActionLimit} actionLimit
 * @param {boolean} isPQLMessage needed to special case some lang messages for PQLs
 * @returns FormattedMessage | null
 */
export const getActionLimitMessage = (actionLimit, isPQLMessage = false) => {
  const status = actionLimit.getStatus();
  switch (status) {
    case AT_ACTION_LIMIT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.actionLimits.AT_ACTION_LIMIT",
        options: {
          count: actionLimit.getLimit()
        }
      });
    case OVER_ACTION_LIMIT:
      if (isPQLMessage) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.common.actionLimits.pql.OVER_ACTION_LIMIT",
          options: {
            count: actionLimit.getLimit()
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation.common.actionLimits.OVER_ACTION_LIMIT",
        options: {
          count: actionLimit.getLimit()
        }
      });
    default:
      return null;
  }
};